import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_EXTENSIONS = new Set(['pdf', 'doc', 'docx', 'xls', 'xlsx']);

@Component({
  selector: 'task-attachment-dialog',
  imports: [MatButtonModule, MatDialogModule, TranslocoDirective],
  templateUrl: './task-attachment-dialog.html',
  styleUrl: './task-attachment-dialog.scss',
})
export class TaskAttachmentDialog {
  selectedFiles: File[] = [];

  constructor(private readonly dialogRef: MatDialogRef<TaskAttachmentDialog, File[]>) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) this.selectFiles(input.files);
    input.value = '';
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files.length) this.selectFiles(event.dataTransfer.files);
  }

  upload(): void {
    if (this.selectedFiles.length) this.dialogRef.close(this.selectedFiles);
  }

  removeFile(index: number): void {
    this.selectedFiles = this.selectedFiles.filter((_, fileIndex) => fileIndex !== index);
  }

  private selectFiles(fileList: FileList): void {
    const validFiles = Array.from(fileList).filter(file => this.isValidFile(file));
    this.selectedFiles = [...this.selectedFiles, ...validFiles];
  }

  private isValidFile(file: File): boolean {
    const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
    return ALLOWED_EXTENSIONS.has(extension) && file.size <= MAX_FILE_SIZE;
  }
}
